import React from 'react';
import type { Card } from '@ctd/agent-contract';
import { CardFrame } from './card-frame';
import { MetricBlock, MetricFigures } from './metric-block';
import style from '../style.module.scss';

export const ComparisonCard: React.FC<{
    card: Extract<Card, { shape: 'comparison' }>;
}> = ({ card }) => (
    <CardFrame card={card}>
        <div className={style.metrics}>
            {card.primary.map((metric) => (
                <MetricBlock key={metric.id} metric={metric} title={card.title}>
                    <MetricFigures metric={metric} />
                </MetricBlock>
            ))}
        </div>
    </CardFrame>
);
